import type { GetStaticProps } from 'next'
import ImageBanner from '@components/ImageBanner'
import type { pageTitle, pageContent } from '@lib/types'
import { getPageTitleContentFromDB, getPageContentFromDB } from '@lib/pagequerys'
import MenuList from '@components/MenuList'
import { Container, Heading, Section, Spacer, Text } from '@components/SectionComponents'
import OpenTableComponentNew from '@components/OpenTableComponent/OpenTableComponentNew'

export const getStaticProps: GetStaticProps = async () => {

  // page_id in DB
  const pageIdDB: number = 28;

  // query DB for page title data
  const pageTitle: pageTitle = await getPageTitleContentFromDB(pageIdDB);

  // Array of pageContent - query DB for pageContent data
  const pageContent: pageContent[] = await getPageContentFromDB(pageIdDB);

  return {
    props: {
      pageTitle,
      pageContent,
    }
  }
}

// Home Page takes a pageTitle, and pageContent array
export default function Page({ pageTitle, pageContent }: {
  pageTitle: pageTitle,
  pageContent: pageContent[],
}) {

  return (
    <>

      <ImageBanner title={pageTitle} />

      {/* Section 0 */}
      <Section colour='brown'>
        <Container>
          <Heading h1={true} content={{ title: pageContent[0].title }} />
          <Text content={pageContent[0].text} />
          <Spacer type='medium' />
          <OpenTableComponentNew />
        </Container>
      </Section>

      {/* Section 1 */}
      <Section colour='white'>
        <Container>
          <Heading content={{ title: pageContent[1].title }} />
          <Spacer type={'medium'} />
          <Spacer type={'medium'} />
          <div>
            <MenuList wide={true} content={pageContent[1].list} />
          </div>
        </Container>
        <Text content={pageContent[1].text} />
      </Section>

      {/* Section 2 */}
      <Section colour='cream'>
        <Container>
          <Heading content={{ title: pageContent[2].title }} />
          <Spacer type={'medium'} />
          <Spacer type={'medium'} />
          <div>
            <MenuList wide={true} content={pageContent[2].list} />
          </div>
        </Container>
      </Section>

    </>
  )
}

//Meta Data
Page.title = "Menu";
Page.description = "Our menu’s identity is derived from the classical techniques of the world with the modernisation that is Australian cooking. Executive Chef Craig Milnes spends his time sourcing beautiful local ingredients to create these dishes.";